import React, { useEffect, useState } from "react";
import { Box, Container } from "@mui/material";
import { ResourceLinks } from "../../../../constants";
import { makeArrayRandom } from "../../../../utils/learner";
import { useSelector } from "../../../../store";

export default function WebMatchTextSelectionResources({ question, onAnswer = () => {} }) {
    const questionData = question;
    const learnerState = useSelector((state) => state.learner || {});
    const data = learnerState?.details?.testLevel === "vfh" ? questionData?.vfh : questionData?.acsf4;
    const imagesResources = ResourceLinks.llnQuizImage;

    const [selectedKeyPrevious, setSelectedKeyPrevious] = useState(null);
    const [clickableItems, setClickableItems] = useState(
        makeArrayRandom(Object.values(data.choices))
    );

    const [answers, setAnswers] = useState(
        Object.keys(questionData.answer.value).reduce((acc, key) => {
            acc[key] = "";
            return acc;
        }, {})
    );

    const [selectedItem, setSelectedItem] = useState(null);

    // every time question change we will set to reset needed to reset
    useEffect(() => {
        setSelectedKeyPrevious(null);
        setClickableItems(makeArrayRandom(Object.values(data.choices)));
        setSelectedItem(null);
    }, [question,
        data.choices,
    ]);

    const handleDraggableClick = (item) => {
        setSelectedItem(item);
        setSelectedKeyPrevious(null);
    };

    const handleAnswer = (index) => {
        const answerKey = Object.keys(answers)[index];
        if (answers[answerKey] && !selectedItem) {
            // const item = answers[answerKey].toLowerCase();
            const item = answers[answerKey];
            setSelectedItem(item);
            setSelectedKeyPrevious(answerKey);
        }

        if (selectedItem && (selectedItem.toLowerCase() !== answers[answerKey].toLowerCase())) {
            const updatedAnswers = { ...answers };

            let currentClickableItems = [...clickableItems];

            // first we will check if there is selected previous
            if (updatedAnswers[answerKey] !== "") {
                currentClickableItems = [...currentClickableItems, updatedAnswers[answerKey]];
            }

            // we will check here if coming from previous answer
            if (selectedKeyPrevious !== null) {
                // delete currentWebsiteChoices[selectedKeyPrevious];
                updatedAnswers[selectedKeyPrevious] = "";
                setSelectedKeyPrevious(null);
            }

            updatedAnswers[answerKey] = selectedItem;

            setAnswers(updatedAnswers);

            const canProceed = true;
            onAnswer({
                canProceed,
                answer: updatedAnswers,
            });

            setClickableItems(
                currentClickableItems.filter((item) => item.toLowerCase() !== selectedItem?.toLowerCase())
            );

            setSelectedItem(null);
        }
    };

    const handleRemoveAnswer = (index) => {
        const answerKey = Object.keys(answers)[index];

        const updatedAnswers = { ...answers };
        const removedItem = updatedAnswers[answerKey];

        updatedAnswers[answerKey] = "";
        setAnswers(updatedAnswers);

        const canProceed = updatedAnswers.length > 0;
        onAnswer({
            canProceed,
            answer: updatedAnswers,
        });

        if (removedItem) {
            setClickableItems([...clickableItems, removedItem]);
        }
    };

    return (
        <Box
            sx={{
                // margin: "0 auto",
            }}
        >
            <Container maxWidth="lg" sx={{ px: { xs: 2 } }}>
                <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="stretch"
                    backgroundColor="white"
                    sx={{
                        flexWrap: "wrap",
                        "@media (min-width: 540px)": {
                            flexWrap: "nowrap",
                        },
                    }}
                    px={2}
                >
                    {/* Left Box */}
                    <Box
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                        mr={1}
                        mb={0}
                        py={1}
                        sx={{ flexShrink: 1 }}
                    >
                        <Box
                            display="flex"
                            flexWrap="wrap"
                            justifyContent="center"
                            mb={1}
                            sx={{
                                width: "100%",
                                border: "1px dashed lightgrey",
                            }}
                        >
                            {clickableItems.map((item, index) => (
                                <Box
                                    key={index}
                                    onClick={() => handleDraggableClick(item)}
                                    style={{
                                        flexBasis: "45%",
                                        textAlign: "center",
                                        borderBottom:
                                            "10px solid rgb(52, 148, 186)",
                                        fontWeight: "bold",
                                        margin: "5px 5px 5px 0",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        height: "40px",
                                        backgroundColor: "rgb(170, 214, 231)",
                                        padding: "4px",
                                        cursor: "pointer",
                                        boxShadow:
                                            selectedItem?.toLowerCase() === item.toLowerCase()
                                                ? "rgb(199, 0, 199) 0px 0px 0px 3px"
                                                : "none",
                                    }}
                                >
                                    {item}
                                </Box>
                            ))}
                        </Box>

                        <Box component="img"
                            src={`${imagesResources}${data.image}`}
                            alt="Question"
                            sx={{
                                width: "100%",
                                height: "auto",
                                minWidth: "150px",
                                flexShrink: 1,
                                flexGrow: 1,
                            }}
                        />
                    </Box>

                    {/* Right Box */}
                    <Box
                        display="flex"
                        flexDirection="column"
                        ml={0}
                        py={1}
                        sx={{
                            width: { xs: "100%", sm: "auto" },
                            flexShrink: 1,
                        }}
                    >
                        {questionData.descriptions.map((description, index) => (
                            <Box
                                key={index}
                                display="flex"
                                mb={
                                    index !== questionData.descriptions.length - 1
                                        ? 0
                                        : 2
                                }
                                sx={{
                                    flexWrap: "nowrap",
                                    width: "100%",
                                }}
                            >
                                <Box
                                    display="flex"
                                    flexGrow={1}
                                    borderBottom="10px solid rgb(37, 56, 71)"
                                    backgroundColor="rgb(205, 218, 230)"
                                    padding="10px"
                                    sx={{
                                        width: {
                                            xs: "100%",
                                            "@media (min-width: 800px)": {
                                                width: "480px",
                                            },
                                        },
                                    }}
                                >
                                    <Box
                                        sx={{
                                            flexGrow: 1,
                                            backgroundColor: "white",
                                            padding: "5px",
                                            display: "block",
                                            width: "100%",
                                            borderTop: "10px solid rgb(37, 56, 71)",
                                            fontWeight: "bold",
                                        }}
                                    >
                                        {description}
                                    </Box>
                                </Box>

                                {/* Right Answer Box */}

                                <Box
                                    display="flex"
                                    alignItems="center"
                                    justifyContent="center"
                                    backgroundColor="#808c8c"
                                    height="auto"
                                    width="140px"
                                    cursor="pointer"
                                    ml={0}
                                    onClick={() => handleAnswer(index)}
                                    sx={{
                                        lineHeight: "2.2rem",
                                        fontWeight: "bold",
                                        backgroundColor: "#808c8c",
                                        borderRadius:
                                            index === 0
                                                ? "10px 10px 0 0"
                                                : index ===
                                                questionData.descriptions.length -
                                                    1
                                                ? "0 0 10px 10px"
                                                : "0",
                                        borderTop: index !== 0 ? "none" : "10px",
                                        borderBottom:
                                            index ===
                                            questionData.descriptions.length - 1
                                                ? "10px solid rgb(91, 105, 107)"
                                                : "none",
                                        marginTop: index !== 0 ? "-1px" : "0",
                                        marginLeft: "10px",
                                    }}
                                >
                                    <Box
                                        sx={{
                                            position: "relative",
                                            backgroundColor:
                                                answers[
                                                    Object.keys(answers)[index]
                                                ] !== ""
                                                    ? "rgb(170, 214, 231)"
                                                    : "white",
                                            width: "80%",
                                            height: "40px",
                                            textAlign: "center",
                                            boxShadow: selectedItem
                                                ? "rgb(199, 0, 199) 0px 0px 0px 3px"
                                                : "none",
                                            borderTop: answers[
                                                    Object.keys(answers)[index]
                                                ] === ""
                                                ? "10px solid rgb(91, 105, 106)"
                                                : "none"
                                        }}
                                    >
                                        {answers[Object.keys(answers)[index]] !== ""
                                            ? answers[Object.keys(answers)[index]]
                                            : "\u00A0"}
                                        {answers[Object.keys(answers)[index]] && (
                                            <Box component="span"
                                                className="selected-close-btn"
                                                sx={{
                                                    top: 0,
                                                    right: 0,
                                                    padding: "0 4px 0 4px",
                                                    fontWeight: "700",
                                                    fontSize: "12px",
                                                    lineHeight: "1.2rem",
                                                }}
                                                onClick={(e) => {
                                                    handleRemoveAnswer(index);
                                                }}
                                            >
                                                X
                                            </Box>
                                        )}
                                    </Box>
                                </Box>
                            </Box>
                        ))}
                    </Box>
                </Box>
            </Container>
        </Box>
    );
};
